import { Map } from 'immutable';

import {
  FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS,
} from './actions';
import HomeworkType from './model';

export default function homeworkTypesReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS:
      return addTypesToMap(state, action);
    default:
      return state;
  }
}

function addTypesToMap(state, { payload, courseTypeLevelId }) {
  let newState = state;
  if (payload && payload.length > 0) {
    payload.forEach((type) => {
      const model = HomeworkType.create(
        Object.assign({}, type, { courseTypeLevelId })
      );
      newState = newState.set(model.id, model);
    });
  }
  return newState;
}



// WEBPACK FOOTER //
// ./data/Homework/Types/reducer.js